import Image from 'next/image'

const CUSTOMER_LIST = [
  {
    image: './images/payment-ver2/cus1.png',
    name: 'Anh Minh - Hà Nội',
    title: 'Chủ cửa hàng tạp hóa ',
    comment: 'Từ khi được KiotViet hỗ trợ giải pháp này, tôi bán hàng nhàn hẳn. Cứ ngồi lên hóa đơn tính tiền thôi, rồi xem thông báo khách chuyển trên màn hình. Đỡ phải mất công chụp lại màn hình.',
  },
  {
    image: './images/payment-ver2/cus2.png',
    name: 'Cô Giang - Hà Nội',
    title: 'Chủ chuỗi cửa hàng hoa quả tươi',
    comment: 'Trước đây chị hay chụp lại màn hình chuyển tiền cho chắc, giờ có ứng dụng này thì mình yên tâm khách chuyển thì loa nói ro rõ ràng luôn rồi. ',
  },
  {
    image: './images/payment-ver2/cus3.png',
    name: 'Anh Bình - Hồ Chí Minh',
    title: 'Chủ hiệu thuốc tư nhân',
    comment: 'Giờ mọi người mua hàng thì ai ai cũng chuyển khoản, mà cô thấy mỗi chữ thành công là được cũng không để ý đã nhận được chưa. Khi KiotViet tư vấn thì cô yên tâm hơn nhiều, không sợ bị hụt tiền nữa.',
  },
  {
    image: './images/payment-ver2/cus4.png',
    name: 'Anh Huy - Hà Nội',
    title: 'Chủ quán lẩu & nướng bình dân',
    comment: 'Trước tôi cũng in mã QR dán lên bàn, Lúc quán đông mà khách thanh toán thì cũng nhìn qua không để ý tiền về chưa. Có ứng dụng này rồi tôi không sợ bị dán đè mã QR nữa, thông báo tiền về cũng nhanh.',
  },
]

export default function Customer() {
  function onNavigate(action) {
    const isBack = action === 'back'
    const container = document.getElementById('list-customer')
    if (container) {
      const scrollLeft = container.scrollLeft // Vị trí cuộn từ trái sang phải
      const scrollWidth = container.scrollWidth // Chiều rộng tổng của nội dung
      const clientWidth = container.clientWidth // Chiều rộng của div
      const percentScrolled = (scrollLeft / (scrollWidth - clientWidth)) * 100
      let targetPosition
      if (percentScrolled < 25) {
        targetPosition =  Math.ceil((isBack ? 1 : 0.25) * scrollWidth)
      } else if (percentScrolled < 50) {
        targetPosition =  Math.ceil((isBack ? 0 : 0.5) * scrollWidth)
      } else if (percentScrolled < 75) {
        targetPosition =  Math.ceil((isBack ? 0.25 : 0.75) * scrollWidth)
      } else if (percentScrolled < 100) {
        targetPosition =  Math.ceil((isBack ? 0.5 : 1) * scrollWidth)
      } else {
        targetPosition = 0
      }
      container.scrollTo({
        left: targetPosition,
        behavior: 'smooth',
      })
    }
  }

  return <div className="mx-auto flex flex-col lg:py-20 py-12 xl:px-[83px] lg:px-12 md:px-8 px-[18px] lg:gap-12 gap-6">
    <div className="mx-auto font-bold lg:text-3xl text-2xl leading-9 text-brand-primary-850 text-center">
      Khách hàng nói về chúng tôi
    </div>
    <div className="flex lg:flex-row flex-col gap-4 justify-center">
      <div className="flex flex-col gap-11 lg:w-[262px] w-fit max-lg:text-center max-lg:mx-auto">
        <div className="flex flex-col gap-3">
          <div className="font-extrabold text-[54px] leading-[68px] text-brand-primary-500">35.000+</div>
          <div className="font-semibold text-lg leading-[26px] text-text-strong">
            Chủ cửa hàng trên toàn quốc đã sử dụng
          </div>
        </div>
        <div className="flex gap-4 max-lg:hidden">
          <div onClick={() => onNavigate('back')} className="cursor-pointer">
            <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="50" height="50" rx="25" fill="#F0F1F3" />
              <path
                d="M28.707 18.293C29.1641 18.8008 29.1641 19.5625 28.707 20.0195L23.4766 25.25L28.707 30.4805C29.1641 30.9883 29.1641 31.75 28.707 32.207C28.1992 32.7148 27.4375 32.7148 26.9805 32.207L20.8867 26.1133C20.3789 25.6562 20.3789 24.8945 20.8867 24.4375L26.9805 18.293C27.4375 17.8359 28.1992 17.8359 28.6562 18.293H28.707Z"
                fill="#525D6A" />
            </svg>
          </div>
          <div onClick={() => onNavigate('next')} className="cursor-pointer">
            <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="50" height="50" rx="25" fill="#F0F1F3" />
              <path
                d="M21.293 32.207C20.7852 31.75 20.7852 30.9883 21.293 30.5312L26.5234 25.3008L21.293 20.0195C20.7852 19.5625 20.7852 18.8008 21.293 18.3438C21.75 17.8359 22.5117 17.8359 22.9688 18.3438L29.1133 24.3867C29.5703 24.8945 29.5703 25.6562 29.1133 26.1133L23.0195 32.207C22.5117 32.7148 21.75 32.7148 21.293 32.207Z"
                fill="#525D6A" />
            </svg>
          </div>
        </div>
      </div>
      <div id="list-customer" className="lg:max-w-[866px] max-w-[1279px] overflow-x-auto no-scrollbar">
        <div className="flex gap-6 w-fit">
          {CUSTOMER_LIST.map((customer, index) => (
            <div id={`customer-${index + 1}`} key={customer.title}
                 className="p-6 bg-neutral-25 rounded-2xl lg:w-[384px] w-[348px] flex flex-col gap-[50px]">
              <div className="flex gap-4">
                <div className="relative size-[54px]">
                  <Image src={customer.image} alt={customer.title} fill={true} />
                </div>
                <div className="flex flex-col gap-2">
                  <div className="font-semibold text-lg leading-[26px] text-brand-navy">{customer.name}</div>
                  <div className="font-normal text-base text-text-secondary">{customer.title}</div>
                </div>
              </div>
              <div className="font-normal text-base text-text-strong">{customer.comment}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
}